<div class="confirmar-salida" mat-dialog-content>
  <header class="modal-header">
    <h2 class="title-medium font-brand weight-bold">{{ 'Tienes cambios sin guardar' | translate }}</h2>
    <p class="body-small text-secondary">
      {{ 'Si sales ahora se perderán los cambios que hiciste en esta pantalla.' | translate }}
    </p>
  </header>
</div>

<div class="confirmar-salida-actions" mat-dialog-actions>
  <button type="button" class="outlined" (click)="salir()">{{ 'Salir sin guardar' | translate }}</button>
  <button type="button" class="filled" (click)="quedarse()">{{ 'Seguir editando' | translate }}</button>
</div>
